<!-- 表2填写 -->

<template>
  <div class="tabCage table8E">
    <div class="tabTtl">
      <span>表 1-8：人员基本情况登记表</span>
    </div>
    <div class="editArea">
      <el-form ref="paramCk" :model="params" :rules="rules">
        <table>
          <tr>
            <td class="edName">岗位类别：</td>
            <td class="radioText">
              <el-form-item prop="type" :inline-message="true">
                <!-- <el-radio-group v-model="params.type" @change="tabSeek"> -->
                <el-radio-group v-model="params.type">
                  <el-radio :label="1">主要负责人</el-radio>
                  <el-radio :label="2">其他负责人</el-radio>
                  <el-radio :label="3">编辑人员</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">姓名：</td>
            <td class="edInp">
              <el-form-item prop="fullName" :inline-message="true">
                <el-input v-model="params.fullName" size="small" placeholder="请输入姓名"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">性别：</td>
            <td class="radioText">
              <el-form-item prop="gender" :inline-message="true">
                <!-- <el-radio-group v-model="params.gender" @change="tabSeek"> -->
                <el-radio-group v-model="params.gender">
                  <el-radio v-for="item in dicDats['C017']" :label="item.code" :key="item.code"
                    >{{ item.name }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">身份证号（军官证号）：</td>
            <td class="edInp areaTime">
              <el-form-item prop="idNumber" :inline-message="true">
                <el-input v-model="params.idNumber" size="small" placeholder="请输入身份证号或军官证号"></el-input>
              </el-form-item>
              <div class="tips">军官证号填写示例：军字第xxxxxxx号。编号位数据实情填写。</div>
            </td>
          </tr>
          <tr v-if="params.type != 3">
            <td class="edName">职务：</td>
            <td class="edInp areaTime">
              <el-form-item prop="job" :inline-message="true">
                <el-select v-model="params.job" size="small" placeholder="请选职务">
                  <el-option v-for="item in dicDats['C022']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="dicMap['C022'][params.job] == '其他'" prop="professionalOther" :inline-message="true">
                <el-input v-model="params.professionalOther" size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">政治面貌：</td>
            <td class="edInp">
              <el-form-item prop="politicalStatus" :inline-message="true">
                <el-select v-model="params.politicalStatus" size="small" placeholder="请选择政治面貌">
                  <el-option v-for="item in dicDats['C006']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">文化程度：</td>
            <td class="edInp">
              <el-form-item prop="culture" :inline-message="true">
                <el-select v-model="params.culture" size="small" placeholder="请选择文化程度">
                  <el-option v-for="item in dicDats['C005']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">手机号：</td>
            <td class="edInp">
              <el-form-item prop="cellphone" :inline-message="true">
                <el-input v-model="params.cellphone" size="small" placeholder="请输入手机号"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">专业：</td>
            <td class="edInp">
              <el-form-item prop="major" :inline-message="true">
                <el-input v-model="params.major" size="small" placeholder="请输入专业"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">职称系列：</td>
            <td class="edInp">
              <el-form-item prop="professionalTitleSeries" :inline-message="true">
                <el-select v-model="params.professionalTitleSeries" size="small" placeholder="请选择职称系列">
                  <el-option v-for="item in dicDats['C007']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">职称级别：</td>
            <td class="edInp">
              <el-form-item prop="titleLevel" :inline-message="true">
                <el-select v-model="params.titleLevel" size="small" placeholder="请选择职称级别">
                  <el-option v-for="item in dicDats['C008']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">持有出版专业职业资格证书情况：</td>
            <td class="edInp areaTime">
              <el-form-item prop="certificateSituation" :inline-message="true">
                <el-select
                  v-model="params.certificateSituation"
                  @change="btnCtrls(1)"
                  size="small"
                  placeholder="请选择">
                  <el-option v-for="item in dicDats['C009']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <div class="tips">选择持有证书的，必须上传证书图片才能提交</div>
            </td>
          </tr>
          <tr>
            <td class="edName">入职时间：</td>
            <td class="edInp areaTime">
              <el-date-picker v-model="params.rzDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <td class="edName">离职时间：</td>
            <td class="edInp areaTime">
              <el-date-picker v-model="params.lzDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
              </el-date-picker>
              <div class="tips">在职不填写</div>
            </td>
          </tr>
          <tr v-if="btnCtrls1">
            <td class="edName">上传出版专业职业资格证书：</td>
            <td class="edInp">
              <Upbtn class="upBtn" :ableSure="urls1" @upFileId="fileTdSet1" />
              <!-- <div class="tips" style="margin-top:-24px;">注：上传文件格式为JPGE/PNG，文件大小不超过10M</div> -->
            </td>
          </tr>

          <tr v-if="params.type != 3">
            <td class="edName">是否持有岗位培训合格证书：</td>
            <td class="edInp areaTime">
              <el-form-item prop="isTrainCertificate" :inline-message="true">
                <el-select v-model="params.isTrainCertificate" @change="btnCtrls(2)" size="small" placeholder="请选择">
                  <el-option v-for="item in dicDats['C018']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <div class="tips">选择持有证书的，必须上传证书图片才能提交</div>
            </td>
          </tr>
          <tr v-if="btnCtrls2 && params.type != 3">
            <td class="edName">取得岗位证书时间：</td>
            <td class="edInp areaTime">
              <el-date-picker
                v-model="params.trainCertificateDate"
                type="date"
                placeholder="选择日期"
                @change="selectTime"
                :class="highLight == true ? 'hightLight' : ''"
                value-format="yyyy-MM-dd">
              </el-date-picker>
              <div class="tips">岗位类别为主要负责人和其他负责人时需填写</div>
            </td>
          </tr>
          <tr v-if="btnCtrls2 && params.type != 3">
            <td class="edName">上传岗位培训合格证书：</td>
            <td class="edInp">
              <Upbtn class="upBtn" :ableSure="urls2" @upFileId="fileTdSet2" />
            </td>
          </tr>
        </table>
      </el-form>
    </div>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
      <el-button v-if="pubStatus == 0" type="primary" @click="editSave('paramCk')" size="small">保存</el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt8";
import { tabUpdate8, tabRead8 } from "@/api/pressRole/pressRole";
import { detFile } from "@/api/account";
import Upbtn from "@/views/components/uploadCards";
export default {
  components: {
    Upbtn,
  },
  data() {
    return {
      params: bsParams,
      rules: paramsRule,
      submiting: false,
      dicDats: {},

      urls1: "",
      urls2: "",
      btnCtrls1: false,
      btnCtrls2: false,

      dicMap: {
        C018: {},
        C009: {},
        C022: {},
      },
      systemTime: "",
      highLight: false,
      pubStatus: 0,
    };
  },
  methods: {
    // 判断证书取得时间与当前时间的时间差
    selectTime: function (e) {
      this.params.getCertificateTime = new Date(e).getTime();
      //选择时间距今如果超过5年，则高亮显示已过期
      let timeDifference = new Date().getTime() - this.params.getCertificateTime;
      if (timeDifference >= 24 * 60 * 60 * 1000 * 1820) {
        this.highLight = true;
      } else {
        this.highLight = false;
      }
    },
    dictInit: function () {
      let nameArr = ["C017", "C018", "C022", "C006", "C005", "C007", "C008", "C009"];
      let newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr",
      });

      newPromise.then((result) => {
        this.dicDats = result;
        // this.isNot = this.$store.getters.dictionary['C018'];
        // this.isCertificate = this.$store.getters.dictionary['C009'];
        this.dicMap["C018"] = this.$store.getters.dictionary["C018"];
        this.dicMap["C009"] = this.$store.getters.dictionary["C009"];
        this.dicMap["C022"] = this.$store.getters.dictionary["C022"];
      });
    },

    editSave: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.params.publishId = this.$route.query.pressId;
          this.params.publishMaterialId = this.$route.query.mtId;
          this.params.publishType = this.$route.query.pressType;

          let errpop = [];

          if (this.btnCtrls1 && !this.params.professionalCertificateId) {
            errpop.push("请上传出版专业职业资格证书证照");
          }

          if (this.params.type != 3) {
            if (this.btnCtrls2 && !this.params.trainCertificateId) {
              errpop.push("请上传岗位培训合格证书证照");
            }
          }

          if (errpop.length > 0) {
            this.$message.error(errpop[0]);
          } else {
            this.saveAct();
          }
        } else {
          return false;
        }
      });
    },

    saveAct: function () {
      tabUpdate8({
        data: this.params,
        // organizationPersonnel:this.declare,
        publishMaterialId: this.$route.query.mtId,
      })
        .then((response) => {
          console.log("response=", JSON.stringify(response));
          let tipCode = response.payload.pworker.code;
          let tipMessage = response.payload.pworker.message;

          this.submiting = false;
          if (tipCode == -1) {
            this.$message.error(`${tipMessage}`);
          } else {
            console.debug("tabUpdate8: ", response);
            this.submiting = false;
            this.$message({
              message: "保存成功！",
              type: "success",
            });
            // this.editAfter(response);
            this.goBack();
          }
        })
        .catch((error) => {
          this.submiting = false;
        });
    },

    editAfter: function (resDat) {
      if (this.params.professionalCertificateId != this.urls1) {
        detFile({
          id: this.urls1,
        });
      }

      if (this.params.trainCertificateId != this.urls2) {
        detFile({
          id: this.urls2,
        });
      }
    },

    btnCtrls: function (type) {
      if (type == 1) {
        if (this.dicMap["C009"][this.params.certificateSituation] == "暂时没有证书") {
          this.btnCtrls1 = false;
          this.params.professionalCertificateId = "";
          this.urls1 = "";
        } else {
          this.btnCtrls1 = true;
        }
      } else if (type == 2) {
        if (this.dicMap["C018"][this.params.isTrainCertificate] == "否") {
          this.btnCtrls2 = false;
          this.params.trainCertificateId = "";
          this.urls2 = "";
        } else {
          this.btnCtrls2 = true;
        }
      }
    },

    menReEdit: function () {
      tabRead8({
        id: this.$route.query.id,
      }).then((response) => {
        this.params = response.pworker;
        this.urls1 = this.params.professionalCertificateId;
        this.urls2 = this.params.trainCertificateId;

        if (this.dicMap["C009"][this.params.certificateSituation] != "暂时没有证书") {
          this.btnCtrls1 = true;
        }

        if (this.dicMap["C018"][this.params.isTrainCertificate] != "否") {
          this.btnCtrls2 = true;
        }
      });
    },

    fileTdSet1: function (dat) {
      this.params.professionalCertificateId = dat;
    },

    fileTdSet2: function (dat) {
      this.params.trainCertificateId = dat;
    },

    goBack: function () {
      this.$router.go(-1);
    },
  },
  created: function () {
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;
    if (this.$route.query.pgress == 2) {
      this.menReEdit();
    } else {
      this.params.type = 3;
    }
  },

  beforeDestroy: function () {
    for (let key in this.params) {
      this.params[key] = "";
    }
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.hightLight {
  .el-input__inner {
    color: red !important;
  }
}

.table8E .radioText {
  padding-left: 15px;
  padding-bottom: 13px;
}

.table8E .radioText .el-radio__label {
  margin-left: -5px;
}

.table8E .edName {
  width: 240px !important;
}

.table8E .tips {
  display: inline-block;
}

.table8E .areaTime .el-form-item {
  display: inline-block;
  vertical-align: middle;
}

.table8E .areaTime .midSpan {
  margin: 0px 6px;
}

.table8E .areaTime .tips {
  margin-left: 12px;
}

.table8E .upBtn {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// table8.vue?1b95bbdd